import React, { useState, useRef } from "react";
import { Box, Radio, Popper, Paper, ClickAwayListener, Tooltip } from "@mui/material";
import CustomDropdown from "../Common/CustomDropdown";
import { getStatusOptions } from "../../utils/utils";

type Props = {
  value: string;
  canEdit: boolean;
  isAIGenerated?: boolean;
  onChange: (newStatus: string) => void;
  onOpen?: () => void;
  onClose?: () => void;
  noBorder?: boolean;
  minWidth?: string;
  tooltipTitle?: string;
};


const ActionItemsStatusCell: React.FC<Props> = ({
  value,
  canEdit,
  onChange,
  onOpen,
  onClose,
  minWidth,
  tooltipTitle
}) => {
  const [open, setOpen] = useState(false);
  const anchorRef = useRef<HTMLDivElement | null>(null);
  const STATUS_OPTIONS = getStatusOptions();
  const availableOptions = STATUS_OPTIONS

  const handleToggle = () => {
    if (canEdit && value !== "draft") {
      const newOpen = !open;
      setOpen(newOpen);

      if (newOpen) onOpen?.();
      else onClose?.();
    }
  };

  const handleClose = () => {
    setOpen(false);
    onClose?.();
  };
  const selectedOpt = STATUS_OPTIONS.find((s) => s.value === value);

  const handleSelect = (status: string | string[] | null) => {
    if (!status) return;
    const newStatus = Array.isArray(status) ? status[0] : status;
    onChange(newStatus);
    handleClose();
  };

   /** The radio + text content */
   const statusContent = (
    <>
      <Radio checked className= "status-radio"
      sx={{
        color: selectedOpt?.color,
        "&.Mui-checked": {
          color: selectedOpt?.color,
        },
      }}
      />
      <span className="status-label">
        {STATUS_OPTIONS.find((s) => s.value === value)?.label}
      </span>
    </>
  );

  /** Tooltip wrapper (only if tooltipTitle exists) */
  const wrappedWithTooltip =
    tooltipTitle ? (
      <Tooltip title={tooltipTitle} arrow placement="top">
        <span style={{ display: "inline-flex", alignItems: "center" }}>
          {statusContent}
        </span>
      </Tooltip>
    ) : (
      statusContent
    );
  return (
    <Box
      sx={{ p: 0, display: "flex", alignItems: "center", position: "relative", cursor: canEdit ? "pointer" : "default", width: "100%",}}
      onClick={handleToggle}
    >
      {/* Trigger box */}
      <Box
        ref={anchorRef}
        sx={{
          minWidth: minWidth || 120,
          padding: "4px 1px",
          borderRadius: 1,
          display: "flex",
          alignItems: "center",
        }}
      >
          {wrappedWithTooltip}
      </Box>

      {/* Dropdown list */}
      {open && (
        <Popper
          open={open}
          anchorEl={anchorRef.current}
          placement="bottom-start"
          style={{ zIndex: 1300 }}
        >
          <ClickAwayListener onClickAway={handleClose}>
            <Paper style={{ maxHeight: 200, overflowY: "auto", marginTop: 4 }}
            onClick={(e) => e.stopPropagation()}>
              <CustomDropdown<string>
                items={availableOptions.map((opt) => opt.value)} // backend values
                value={value}
                onChange={handleSelect}
                showSearch={false}
                maxHeight = {300}
                showAllWhenNoSearch={true}
                renderItem={(statusValue, isSelected) => {
                  const opt = STATUS_OPTIONS.find((s) => s.value === statusValue)!;
                  return (
                    <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                        <Radio
                          checked={isSelected}
                          className="status-radio"
                          sx={{
                            color: opt.color,
                            "&.Mui-checked": {
                              color: opt.color,
                            }
                          }}
                        />
                      <span className="status-label">{opt.label}</span>
                    </Box>
                  );
                }}
              />
            </Paper>
          </ClickAwayListener>
        </Popper>
      )}
    </Box>
  );
};

export default ActionItemsStatusCell;
